var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 43"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    x: 0.918,
    y: 0.5,
    fill: "currentColor",
    rx: 21
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.918,
    cy: 21.5,
    r: 21,
    fill: "#D91016"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.418 20.634a1 1 0 0 1 0 1.732l-9 5.196a1 1 0 0 1-1.5-.866V16.304a1 1 0 0 1 1.5-.866z"
  })));
};
export default SvgPlay;